(function () {
  'use strict';

  var component = {
    template:'<div hl-sticky enable="$ctrl.sticky == \'true\'" anchor="bottom" ng-class="{ \'hq-lighting-footer--sticky\': $ctrl.sticky == \'true\' }" class="hq-lighting-footer"><div class="hq-lighting-footer__wrapper"><div ng-if="($ctrl.value | number:0) && $ctrl.minValue <= 0" class="hq-lighting-footer__value"><b>{{$ctrl.value | number:0 }}</b> {{$ctrl.unit}}</div><a class="return-button" ng-class="{ desactive: $ctrl.disabled === \'true\' }" ui-sref="{{$ctrl.lref}}" tabindex="{{$ctrl.disabled === \'true\' && -1}}" ng-click="$ctrl.disabled !== \'true\' ? $ctrl.onclick() : null" ;>{{"RETURN" | translate}}</a> <a class="button alt" ng-class="{ desactive: $ctrl.disabled === \'true\' }" ng-href="{{$ctrl.getHref()}}" tabindex="{{$ctrl.disabled === \'true\' && -1}}" ng-click="$ctrl.disabled !== \'true\' ? ($ctrl.clickType ? $ctrl.clickType() : $ctrl.onclick()) : null" ;>{{$ctrl.translateKey | translate}}</a></div></div>',
    controller: footerController,
    bindings: {
      disabled: '@',
      translateKey: '@',
      sref: '@',
      lref: '@',
      value: '@',
      minValue: '@',
      maxValue: '@',
      unit: '@',
      sticky: '@',
      clickType: '&?',
    },
  };

  function footerController($state, hqTLightingOptions) {
    'ngInject';

    var ctrl = this;

    ctrl.getHref = function () {
      if (ctrl.disabled !== 'true') {
        return $state.href(ctrl.sref);
      }
      return null;
    };

    ctrl.onclick = function () {
      var kelvinObject = {};
      if ($state.current.name === 'kelvins') {
        kelvinObject = {
          total: ctrl.minValue + ' - ' + ctrl.maxValue,
          min: ctrl.minValue,
          max: ctrl.maxValue
        };
        hqTLightingOptions.kelvinsSelection = kelvinObject;
      }
    };
  }

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingFooter', component);
}());
